"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gsap_1 = require("gsap");
const Chapter_1 = __importDefault(require("./Chapter"));
class ChapterEnd extends Chapter_1.default {
    constructor(stage, text, key) {
        super();
        this.text = text;
        this.key = key;
        this.stage = stage;
        this.circle = null;
        this.txtKo = null;
    }
    start() {
        this.stage.renderer.setClearColor(0xffffff, 1);
        this.stage.camera.position.set(0, 0, 2);
        this.stage.controls.target.set(0, 0, 0);
        this.stage.controls.update();
        this._animate();
    }
    update() {
    }
    stop(cb) {
        cb();
    }
    _animate() {
        const modal = document.querySelector('#end');
        if (modal) {
            const card = modal.querySelector('#endCard');
            modal.style.display = 'flex';
            gsap_1.gsap.delayedCall(0.1, () => {
                gsap_1.gsap.to(card, {
                    delay: 0.4,
                    duration: 1,
                    opacity: 1,
                    y: 0,
                    ease: 'power1.inOut',
                });
            });
        }
    }
}
exports.default = ChapterEnd;
